/**
 * Entry point into the SRR (Simple Refund & Replace) portal, which now owns the customer-facing
 * refund and replacement flow. The brand is resolved by SRR from the URL, and `environment` is
 * seeded onto window.React from %kernel.environment% by ReactAssetHandler.
 */
export const getSrrRefundUrl = () =>
    window.React?.environment === 'prod'
        ? 'https://srr.wolfe.com?brand=gcg'
        : 'https://srr-staging.wolfe.com?brand=gcg'

export default getSrrRefundUrl
